import type { Route } from "@angular/router";

import { entityObjectiveRoutes, pmoObjectivesRoutes } from "./utils";

export const OBJECTIVES_ROUTES: Route[] = [entityObjectiveRoutes, pmoObjectivesRoutes];
